module.exports = __webpack_public_path__ + "images/9c72d2765a7708db4c64bd4030199070.svg";